const ContentSkillRelevancy = {
    NotVerified: 0,
    Relevant: 1,
    Irrelevant: 2
};

const getContentSkillRelevancyStatus = (relevancy, isVectorBased) => {
    const statusMap = isVectorBased
        ? {
            [ContentSkillRelevancy.NotVerified]: "AI Verified",
            [ContentSkillRelevancy.Relevant]: "SA Verified - Yes",
            [ContentSkillRelevancy.Irrelevant]: "SA Verified - No"
        }
        : {
            [ContentSkillRelevancy.NotVerified]: "Not verified",
            [ContentSkillRelevancy.Relevant]: "Yes",
            [ContentSkillRelevancy.Irrelevant]: "No"
        };
        
    return statusMap[relevancy];
};

export {
    ContentSkillRelevancy,
    getContentSkillRelevancyStatus
};
